<button kendoButton [primary]="false" class="item"
   [ngClass]="{'collapsed': collapsed, 'parent': parent, 'active': isActive(), 'collapsible': collapsible}"
   [routerLink]="link"
   (click)="toggleCollapse()">
    <div class="active-element" [@inOut]="isActive()"></div>
    <i class="material-icons item-icon {{icon}}">
    </i>
    <span class="name">{{name}}</span>
</button>

<div class="children" [ngStyle]="{'height': collapsed ? 0 : 'auto'}" [@collapse]="collapsed" *ngIf="parent && !empty">
    <ng-content></ng-content>
</div>
